"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SavedBlockViewStore_1 = require("SavedBlock/SavedBlockViewStore");
var mobx_1 = require("mobx");
var MultiSelectStore_1 = __importDefault(require("Common/MultiSelectStore/MultiSelectStore"));
var SavedBlockLibraryViewStore = (function (_super) {
    __extends(SavedBlockLibraryViewStore, _super);
    function SavedBlockLibraryViewStore(savedBlockDataStore, savedBlockService) {
        var _this = _super.call(this, savedBlockDataStore, savedBlockService, { enabled: true, localStorageKeyPrefix: "" }) || this;
        _this.isSameFolder = function (folderId) {
            return folderId === _this._currentFolder;
        };
        _this.isBlockSelected = function (index) {
            return (0, mobx_1.computed)(function () {
                return _this.multiSelectStore.isSelected(index);
            }).get();
        };
        _this.clearSelectedBlocks = function () {
            _this.multiSelectStore.clearAllSelections();
            _this.setSearchTerm("");
            _this.clearAllFilters();
        };
        _this.toggleSelectAllBlocks = function () {
            if (_this.isAllSelected) {
                _this.clearSelectedBlocks();
            }
            else {
                _this.multiSelectStore.setSelection(_this.savedBlocks.map(function (block, index) { return index; }));
            }
        };
        _this.bulkDelete = function () { return __awaiter(_this, void 0, Promise, function () {
            var selectedBlocks, ids;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedBlocks = this.savedBlocks.filter(function (block, index) { return _this.multiSelectStore.isSelected(index); });
                        ids = selectedBlocks.map(function (block) { return block.id; });
                        return [4, this.savedBlockService.onConfirmBulkDelete(ids)];
                    case 1:
                        _a.sent();
                        this.clearSelectedBlocks();
                        return [2];
                }
            });
        }); };
        _this.toggleBlockSelection = function (index) {
            if (_this.multiSelectStore.isSelected(index)) {
                _this.removeBlock(index);
            }
            else {
                _this.addBlock(index);
            }
        };
        _this.rangeSelect = function (clickIndex) {
            _this.multiSelectStore.rangeSelect(clickIndex);
        };
        _this.multiSelectStore = new MultiSelectStore_1.default();
        return _this;
    }
    Object.defineProperty(SavedBlockLibraryViewStore.prototype, "isAllSelected", {
        get: function () {
            return this.multiSelectStore.selectedCount !== 0 && this.multiSelectStore.selectedCount === this.savedBlocks.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockLibraryViewStore.prototype, "selectedBlockIds", {
        get: function () {
            var _this = this;
            var selectedBlockIds = [];
            this.savedBlocks.forEach(function (block, index) {
                if (_this.multiSelectStore.isSelected(index)) {
                    selectedBlockIds.push(block.id);
                }
            });
            return selectedBlockIds;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockLibraryViewStore.prototype, "selectedBlockIndexes", {
        get: function () {
            return this.multiSelectStore.sortedIndices;
        },
        enumerable: false,
        configurable: true
    });
    SavedBlockLibraryViewStore.prototype.addBlock = function (index) {
        this.multiSelectStore.addSelection(index);
    };
    SavedBlockLibraryViewStore.prototype.removeBlock = function (index) {
        this.multiSelectStore.removeSelection(index);
    };
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SavedBlockLibraryViewStore.prototype, "isAllSelected", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockLibraryViewStore.prototype, "clearSelectedBlocks", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockLibraryViewStore.prototype, "toggleSelectAllBlocks", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SavedBlockLibraryViewStore.prototype, "addBlock", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SavedBlockLibraryViewStore.prototype, "removeBlock", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockLibraryViewStore.prototype, "bulkDelete", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockLibraryViewStore.prototype, "toggleBlockSelection", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockLibraryViewStore.prototype, "rangeSelect", void 0);
    return SavedBlockLibraryViewStore;
}(SavedBlockViewStore_1.SavedBlockViewStore));
exports.default = SavedBlockLibraryViewStore;
